import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  button: {
    fontFamily: 'TTRounds',
    display: 'inline-block',
    padding: '10px 20px',
    backgroundColor: theme.colors.main,
    color: '#fff',
    borderRadius: '10px',
    lineHeight: '18px',
    fontSize: '15px',
    fontWeight: 700,
    textDecoration: 'none',
    transition: 'all 250ms cubic-bezier(.215,.61,.355,1)',
    '&:hover': {
      backgroundColor: theme.colors.mainHover,
      textDecoration: 'none',
    },
  },
  buttonPri: {
    fontFamily: 'TTRounds',
    display: 'inline-block',
    padding: '10px 20px',
    backgroundColor: theme.colors.orange,
    color: '#fff',
    borderRadius: '10px',
    lineHeight: '18px',
    fontSize: '15px',
    fontWeight: 700,
    textDecoration: 'none',
    transition: 'all 250ms cubic-bezier(.215,.61,.355,1)',
    '&:hover': {
      backgroundColor: theme.colors.orangeHover,
      textDecoration: 'none',
    },
  },
}))

const ButtonLink = ({ text, url, primary }) => {
  const classes = useStyles()
  if (primary) {
    return (
      <a href={url} className={classes.buttonPri}>
        {text}
      </a>
    )
  }

  return (
    <a href={url} className={classes.button}>
      {text}
    </a>
  )
}

export default ButtonLink
